import axiosInstance from "@/utils/helper/axiosInstance";
import { USER_INFO_URL } from "../urls/apiUrls";

export const userService = Object.freeze({
  getUserInfo: async () => {
    try {
      const res = await axiosInstance.get(USER_INFO_URL);
      return res?.data;
    } catch (error) {
      console.log(error, "-----error-----");
      throw error;
    }
  },
});
